import styles from "./TrainingSupport.module.css";
import {
  FaGraduationCap,
  FaChalkboardTeacher,
  FaIndustry,
  FaChartLine,
} from "react-icons/fa";
import servicesbg from "../../../assets/images/school_programmes/servicesbg.png";

const TrainingSupport = () => {
  const supportItems = [
    {
      icon: <FaGraduationCap />,
      title: "Students Training Programs",
      description:
        "We provide training to students on the latest technologies through various interesting methodologies, by which students are able to solve real-life problems.",
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Teachers Training Programs",
      description:
        "We train school teachers to integrate learning and innovation in regular classroom sessions. Our programs have helped teachers to make their class more interesting and informative.",
    },
    {
      icon: <FaIndustry />,
      title: "Project Support by Industry Experts",
      description:
        "Regular technical sessions are provided to students and teachers for exposure to improvise their learning skills. Industry experts visit schools to connect education to industry.",
    },
    {
      icon: <FaChartLine />,
      title: "Assistance and Assessment & Support",
      description:
        "Our dedicated team supports in the lab execution. We also help schools by using our data-driven process to easily review and document their progress periodically.",
    },
  ];

  return (
    <section className={styles.trainingSupport}>
      <img src={servicesbg} alt="servicesbg" className={styles.servicesbg} />

      <div className={styles.container}>
        <h2 data-aos="fade-up">
          Comprehensive <span>Training & Support</span>
        </h2>
        <div className={styles.grid}>
          {supportItems.map((item, index) => (
            <div
              key={index}
              className={styles.card}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.iconWrapper}>{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingSupport;
